import React, { forwardRef, useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import CreateFluidOutputForm from "../templates/CreateFluidOutputForm";

interface Ref {
  show: () => void;
}

const CreateFluidOutputModal = forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);

  useImperativeHandle(ref, () => ({
    show: () => {
      setShowing(true);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Fluid Output"
      hasCancelButton
    >
      <CreateFluidOutputForm onClose={handleClose} />
    </ReusableModal>
  );
});

CreateFluidOutputModal.displayName = "CreateFluidOutputModal";
export { CreateFluidOutputModal };
